import React, { useEffect, useRef, useState, version } from "react";
import OneQueryInput from "./OneQueryInput";
import Api from "../../../one-query/services/ApiServices";
import SignalRService from "../../../one-query/services/SignalRService";
import { useAppSelector, useAppDispatch } from "../../../../store/hooks";
import ChatModel from "./ChatModel";
import Navbar from "./Navbar";
import {
  conversationsActions,
  SetActiveConversationModelStatus,
} from "../../../../store/one-query/conversationSlice";
import {
  signinUserSuccess,
} from "../../../../store/account/userSlice";
import useGetLastActiveModels, {
  useCreateConversation,
  useGetConversationHistory,
  useUpdateConversation,
  useUpdateConversationAnnonyPersona,
} from "../../../../store/Apis/ConversationApi";
import {
  getChatsOpen,
  handleNewConversationRequest,
  setCanSetActiveModels,
  setChat2Data,
  setChat3Data,
  setChat4Data,
  setChat5Data,
  setChat6Data,
  setDisabledVersions,
  setFileError,
  setIsGenerateImage,
  setLimitAlert,
  setSelectedPersona,
  setShowPlansModal,
} from "../../../../store/one-query/chatsSlice";
import { AttachmentPayload } from "../../../../Types";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { ChatModelState, ModelsCompany, ModelsNamesCompany, ModelVersionStatus,} from "../../../../Helper";
import useNavigateToMainPage from "../../../../NavigateToMainPage";
import { LimitAlert } from "../Popups/LimitAlert";
import { ClosedChatsModePopup } from "../Popups/ClosedChatsModePopup";
import { useGetCurrentSubscription } from "../../../../store/Apis/StripeApi";
import { getFileExtension } from "../../../../FileAttachmentHelper";
import { HandleErrorForLimitations } from "../../../../HandleErrorForLimitationsHelper";
import { ImageGeneratorAlert } from "../Alerts/ImageGeneratorAlert";
import { useGetConversationDataVersions } from "../../../../store/Apis/ConversationVersionsApi";
import { setConversationVersionData } from "../../../../store/one-query/conversationVersions";
import { useGetChatModelMessages } from "../../../../store/Apis/ChatModelApi";
import { getChatModelEditsAndResponsesMessages, getModelChatMessage } from "../../../../store/one-query/ChatModelSlice";
interface ModelsProps {
  page: string;
}

const Models = ({ page  }: ModelsProps) => {
  const dispatch = useAppDispatch();
  const { id } = useParams<{ id: string }>();
  // current chats opened ids
  const { Chat1Data, Chat2Data, Chat3Data, Chat4Data, Chat5Data, Chat6Data } =
    useAppSelector((state) => state.ChatsState);
  const isAuthenticated = useAppSelector((s) => s.User.IsAuthenticated);
  const userToken=useAppSelector((s)=>s.User.token)
  const isAnnony: boolean = isAuthenticated ? false : true;
  const [conConIds, setConConIds] = useState<string[]>([]);
  const [imageQuery, setImageQuery] = useState<File>();
  const [queryImage, setQueryImage] = useState();
  const [query, setQuery] = useState("");
  const conversationState = useAppSelector((s) => s.Conversations);
  const chatNum = useAppSelector((s) => s.ChatsState.chatsNum);
  const maximizedChat = useAppSelector((s) => s.ChatsState.maximizedChat);
  const isConHistoryClicked = useAppSelector(
    (s) => s.Conversations.isConversationHistoryClicked
  );
  const lastActiveModels = useAppSelector(
    (s) => s.Conversations.lastActiveModels
  );
  const [attachmentFileData, setAttachmentFileData] =
    useState<{ name: string, extension:string, type: string ,canDownload:boolean,url:string}>({ name: "", extension: "", type: "file" ,canDownload:false,url:""});
  const [imageUploadedURL, setImageUploadedURL] = useState<string>("");
  const isFullWidth = useAppSelector((state) => state.ChatsState.fullWidthMode);
  const currentPersona = useAppSelector(
    (state) => state.ChatsState.selectedPersona
  );
  const conversationModelsIDs = useAppSelector(
    (s) => s.Conversations.conversationConversationModels
  );
  const chatsOpened = useAppSelector(
    (state) => state.ChatsState.selectedOptions
  );
  const [arrayDataModelsIDS, setArrayDataModelsIDS] = useState<string[]>([]);
  const [arrayVersionsData, setArrayVersionsData] = useState<
    ModelVersionStatus[]
  >([]);
  const {data:ConversationVersionsData, refetch:getConversationVersions}=useGetConversationDataVersions()
  useEffect(() => {
    if(userToken)
    getConversationVersions();
  }, [userToken]);
  useEffect(()=>{
    if(ConversationVersionsData) dispatch(setConversationVersionData(ConversationVersionsData));
  },[ConversationVersionsData])
  // const [fileUploaded, setFileUploaded] = useState<any>();
  const newConversation = useAppSelector(
    (state) => state.ChatsState.newConversation
  );
  const disabledVersions = useAppSelector(
    (state) => state.ChatsState.disabledVersions
  );
  const selcectedPerson = useAppSelector(
    (state) => state.ChatsState.selectedPersona
  );
  const updateConversation = useUpdateConversation();
  const updateselectedPersonaAnnony = useUpdateConversationAnnonyPersona();
  const allConversations = useAppSelector(
    (state) => state?.Conversations.conversations
  );
  const userInputRef = useRef<any>(null);
  const user = useAppSelector((s) => s.User);
  const { getLastActiveModels, loading } = useGetLastActiveModels();
  const [modelsIdsState, setModelsIdsState] = useState<string[]>([]);
  const [modelsVersionsState, setModelsVersionsState] = useState<string[]>([]);
  const inputDisabled = arrayVersionsData?.every(
    (obj) => obj.isFinished === true
  );
  const [activeChatIndex, setActiveChatIndex] = useState(0);
  const DataVersionsStore = useAppSelector((s) => s.conversationVersion.data);
  const maximizedChatResponseIsFinished = arrayVersionsData?.some(
    (obj) => obj.version === maximizedChat?.versionName && obj.isFinished
  );
  const versionsData = useAppSelector((s) => s.conversationVersion.data);
  const modelParameters = useAppSelector(
    (s) => s.ModelSettings.modelParameters
  );
  const [conversationId,setConversationId]=useState<string>("")
  const lastActiveUpdateFromFE=useAppSelector((s)=>s.Conversations.lastActiveModelsUpdatedFromFE)
  const navigateToMainPage = useNavigateToMainPage();
  const limitAlert = useAppSelector((s) => s.ChatsState.limitAlert);
  const ChatStore = useAppSelector((s) => s.ChatsState);
  const PromptLibrary = useAppSelector((s) => s.PromptLibrary);
  const [selectedOutputLang, setSelectedOutputLang] = useState<string>("");
  const [showClosedChatsModeModal,setShowClosedChatsModeModal] = useState(false);
  const { mutate: GetCurrentSubscriptionStatus } = useGetCurrentSubscription();
  const [showImageGeneratorAlert, setShowImageGeneratorAlert] = useState(false);
  
  const lastActiveUpdateFromBE = useAppSelector((s) => s.Conversations.lastActiveModelsUpdatedFromBE);

  const SetActiveChat = (index:number) => {
    setActiveChatIndex(index);
  };

  const handleCloseImageGeneratorAlert = () => {
    setShowImageGeneratorAlert(false);
  }
  const formData = new FormData();
  const modelsIds = [
    Chat1Data.id,
    Chat2Data.id,
    Chat3Data.id,
    Chat4Data.id,
    Chat5Data.id,
    Chat6Data.id,
  ];

  const modelsVersions = [
    Chat1Data.version,
    Chat2Data.version,
    Chat3Data.version,
    Chat4Data.version,
    Chat5Data.version,
    Chat6Data.version,
  ];

  const modelsNames = [
    Chat1Data.name,
    Chat2Data.name,
    Chat3Data.name,
    Chat4Data.name,
    Chat5Data.name,
    Chat6Data.name,
  ];

  //handle send selected persona to BE
  useEffect(() => {
    if (id && currentPersona?.title && currentPersona?.title?.length > 0) {
      const conversationName = allConversations?.find(
        (con) => con?.id === conversationState?.activeConversationId
      )?.name;
      if (isAuthenticated) {
        updateConversation({
          id: conversationState?.activeConversationId,
          name: conversationName,
          personaId: currentPersona?.id,
        });
      } else {
        updateselectedPersonaAnnony({
          id: conversationState.activeConversationId,
          personaId: currentPersona.id,
        });
      }
    }
  }, [id, currentPersona]);

 
  useEffect(() => {
    if (id) {
      getLastActiveModels(id);
      dispatch(conversationsActions.setActiveConversation(id));
    } else {
      dispatch(handleNewConversationRequest());
    }
    // Get current subscriptions status request.
    GetCurrentSubscriptionStatus();
  }, []);

  useEffect(() => {
    if (chatNum === 1) {
      dispatch(setChat2Data({ id: "", version: "", name: "" }));
      dispatch(setChat3Data({ id: "", version: "", name: "" }));
      dispatch(setChat4Data({ id: "", version: "", name: "" }));
      dispatch(setChat5Data({ id: "", version: "", name: "" }));
      dispatch(setChat6Data({ id: "", version: "", name: "" }));
    } else if (chatNum === 2) {
      dispatch(setChat3Data({ id: "", version: "", name: "" }));
      dispatch(setChat4Data({ id: "", version: "", name: "" }));
      dispatch(setChat5Data({ id: "", version: "", name: "" }));
      dispatch(setChat6Data({ id: "", version: "", name: "" }));
    } else if (chatNum === 4) {
      dispatch(setChat5Data({ id: "", version: "", name: "" }));
      dispatch(setChat6Data({ id: "", version: "", name: "" }));
    }
  }, [chatNum]);

  useEffect(() => {
    setQuery("");
  }, [chatNum, newConversation]);

  useEffect(() => {
    setModelsIdsState(modelsIds.slice(0, chatNum));
    setModelsVersionsState(modelsVersions.slice(0, chatNum));
    const newArrayVersionsData = modelsVersions
      .slice(0, chatNum)
      .map((versionName) => ({ version: versionName, isFinished: true }));
    setArrayVersionsData(newArrayVersionsData);
  }, [
    chatNum,
    Chat1Data,
    Chat2Data,
    Chat3Data,
    Chat4Data,
    Chat5Data,
    Chat6Data,
  ]);
  const onModelIsFinished = (
    versionName: string,
    isFinishedToggle: boolean
  ) => {
    setArrayVersionsData((prevData) =>
      prevData.map((obj) =>
        obj.version === versionName
          ? { ...obj, isFinished: isFinishedToggle }
          : obj
      )
    );
  };
  const handleEmptyAttachmentFile=()=>{
    setAttachmentFileData((prev)=>({...prev,name:"",extension:""}))
    setImageUploadedURL("")
  } 
  // handle send last active models to BE
  const handleConversationModelStatus = () => {
    if (conversationState.activeConversationId) {
      const MlModelsIds = modelsIds.slice(0, chatNum).map((option, i) => {
        return { id: option, name: modelsNames[i], order: i + 1 };
      });
      const MlModelsIdsWithVersions = MlModelsIds?.map((obj) => {
        const matchedVersion = versionsData.find((v) => v?.id === obj?.id);
        return matchedVersion
          ? { ...obj, version: matchedVersion.version }
          : obj;
      });
      let conversationModelStatus = {
        conversationId: conversationState.activeConversationId,
        models: MlModelsIds,
        MlModelsIdsWithVersions: MlModelsIdsWithVersions,
      };
      dispatch(SetActiveConversationModelStatus(conversationModelStatus));
    }
  };

  useEffect(() => {
    let modeIds = modelsIds.slice(0, chatNum)?.filter((id) => id !== "");
    if (
      !isConHistoryClicked &&
     ChatStore.canSetActiveModels &&
      modeIds.length == chatNum
    ) {
      handleConversationModelStatus();
      dispatch(setCanSetActiveModels(false));
    }
  }, [
    conConIds,
    Chat1Data.id,
    Chat2Data.id,
    Chat3Data.id,
    Chat4Data.id,
    Chat5Data.id,
    Chat6Data.id,
  ]);

  useEffect(() => {
    dispatch(setDisabledVersions(modelsIds));
  }, [
    Chat1Data.id,
    Chat2Data.id,
    Chat3Data.id,
    Chat4Data.id,
    Chat5Data.id,
    Chat6Data.id,
    newConversation,
  ]);

  let selectedConversation = conversationState.conversations.find(
    (con) => con?.id === conversationState.activeConversationId
  );

  // custom hooks to get history messages from chat models
  const {data:GetModelChatMessagesData} = useGetChatModelMessages(conversationId);
  useEffect(() => {
    SignalRService.getInstance();
  }, []);
  useEffect(()=>{
    if(GetModelChatMessagesData)
    {
       dispatch(getModelChatMessage(GetModelChatMessagesData))
        GetModelChatMessagesData.map((item: ChatModelState) =>{
          dispatch(
            getChatModelEditsAndResponsesMessages({
              MessageId: item.id,
              EditMessageIndex: 0,
              ResponseIndex: 0,
            })
          )}
        );
    }
  },[GetModelChatMessagesData])
  useEffect(() => {
    if (lastActiveModels?.length>0){
      const ModelNames = lastActiveModels?.map((obj) => obj.name);
    if (ModelNames?.length > 0)
      dispatch(
        getChatsOpen({
          chatsNum: chatNum,
          selectedOptions: ModelNames.slice(0, chatNum),
        })
      );}
  }, [lastActiveUpdateFromFE]);
  // get messages history from all models

  const getLastActiveModelName = (index: number) => {
    if(lastActiveModels.length >=  chatNum) {
      return lastActiveModels[index].name
    } else {
      return chatsOpened[index];
    }
  }

  useEffect(() => {
    if (isAuthenticated) {
      if (id && lastActiveModels && !newConversation) {
        setConversationId(id);
      }
    } 
  }, [id,lastActiveUpdateFromBE, newConversation]);

  const addStringToArray = (newString: any) => {
    setArrayDataModelsIDS((prevArray) => [...prevArray, newString.id]);
  };

  useEffect(() => {
    setArrayDataModelsIDS([]);
    if (selectedConversation?.conversationConversationModels) {
      for (
        let i = 0;
        i < selectedConversation?.conversationConversationModels?.length;
        i++
      ) {
        if (selectedConversation?.conversationConversationModels[i])
          addStringToArray(
            selectedConversation?.conversationConversationModels[i]
          );
      }
    }
  }, [selectedConversation]);

  const conversationModels = chatsOpened?.map((option, i) => {
    let chatId = "";
    let chatVersion = "";
    if (i === 0) {
      chatId = Chat1Data.id;
      chatVersion = Chat1Data.version;
    } else if (i === 1) {
      chatId = Chat2Data.id;
      chatVersion = Chat2Data.version;
    } else if (i === 2) {
      chatId = Chat3Data.id;
      chatVersion = Chat3Data.version;
    } else if (i === 3) {
      chatId = Chat4Data.id;
      chatVersion = Chat4Data.version;
    } else if (i === 4) {
      chatId = Chat5Data.id;
      chatVersion = Chat5Data.version;
    } else if (i === 5) {
      chatId = Chat6Data.id;
      chatVersion = Chat6Data.version;
    }

    return { name: option, order: i + 1, id: chatId, version: chatVersion};
  });

  const conversationModelsForAnnonymonus = conversationModels?.filter(
    (item) => !["JinaAi"].includes(item.name)
  );

  const conversationWithVersion = conversationModels?.map((model) => {
    const matchedVersion = versionsData?.find((v) => v.id === model.id);
    return matchedVersion
      ? { ...model, version: matchedVersion.version }
      : model;
  });
  const handelNewConversation = async(query: string) => {
    const connectionId = await SignalRService.getInstance().getConnectionId();
    if (newConversation && query !== "") {
      var conversationObj = {
        FirstConversationPrompt: query,
        ConversationModels: conversationModels,
        PersonaId: selcectedPerson?.id,
        PromptId: PromptLibrary.selectedPromptLibrary.id,
        ConnectionId: connectionId
      };
      return conversationObj;
    }
  };

  const receieveUserImageQuery = (imgQueryURL: File) => {
    if (imageQuery) {
      setImageQuery(imgQueryURL);
    }
  };
  const handleFileDelete = () => {
    if (userInputRef.current) {
      userInputRef.current.handleDeleteUploadFile();
    }
  };

  const getModelSettingsForModel = (id: string,chatNum:number) => {
    const objData = DataVersionsStore.find((version) => version.id === id);
    if (objData && objData.name) {
      const modelKey = ModelsNamesCompany[objData.name.toLowerCase()];
      const keyName = `${modelKey} & ${objData.title}`;

      // Find the object in modelParameters where the key matches keyName
      const foundObj = modelParameters?.find(
        (obj) => obj[keyName] !== undefined
      );

      // Return the value if found, otherwise return undefined
      if (foundObj) {
        return (
          formData.append(
            `Models[${chatNum}].ModelSettings.DefaultTemperature`,
            JSON.stringify(foundObj[keyName]?.temperatureCurrentValue)
          ),
          formData.append(
            `Models[${chatNum}].ModelSettings.DefaultMaxToken`,
            JSON.stringify(foundObj[keyName]?.maxTokenCurrentValue)
          ),
          formData.append(
            `Models[${chatNum}].ModelSettings.DefaultTopP`,
            JSON.stringify(foundObj[keyName]?.topPCurrentValue)
          ),
          formData.append(
            `Models[${chatNum}].ModelSettings.DefaultFrequency`,
            JSON.stringify(foundObj[keyName]?.frequencyCurrentValue)
          ),
          formData.append(
            `Models[${chatNum}].ModelSettings.DefaultPresencePenalty`,
            JSON.stringify(foundObj[keyName]?.presencePenaltyCurrentValue)
          ))
      }
    }

    return undefined;
  };

  const handleSendRequest = (
    query: string,
    fileUpload?: any,
    imageUpload?:File[]|null,
    conIDs?: string[],
    activeConId?: string
  ) => {
    if (maximizedChat?.versionName?.length) {
      setArrayVersionsData((prevData) =>
        prevData.map((obj) =>
          obj.version === maximizedChat.versionName
            ? { ...obj, isFinished: false }
            : obj
        )
      );
    } else {
      setArrayVersionsData((prevData) =>
        prevData?.map((obj) => ({
          ...obj,
          isFinished: false,
        }))
      );
    }
    setQuery(query);
    
    setQueryImage(queryImage);
    if (maximizedChat) {
      formData.append(`Models[0].Id`, maximizedChat.versionId);
      formData.append(`Models[0].Key`, maximizedChat.versionName);
       getModelSettingsForModel( maximizedChat.versionId,0);
    } else {
      // Append models data
      if (chatNum > 0) {
        if (Chat1Data.version) {
          formData.append(`Models[0].Id`, Chat1Data.id);
          formData.append(`Models[0].Key`, Chat1Data.version);
           getModelSettingsForModel(Chat1Data.id,0);
        }
        if (Chat2Data.version) {
          formData.append(`Models[1].Id`, Chat2Data.id);
          formData.append(`Models[1].Key`, Chat2Data.version);
          getModelSettingsForModel(Chat2Data.id,1);
        }
      }
      if (chatNum > 2) {
        if (Chat3Data.version) {
          formData.append(`Models[2].Id`, Chat3Data.id);
          formData.append(`Models[2].Key`, Chat3Data.version);
          getModelSettingsForModel(Chat3Data.id,2);
        }
        if (Chat4Data.version) {
          formData.append(`Models[3].Id`, Chat4Data.id);
          formData.append(`Models[3].Key`, Chat4Data.version);
          getModelSettingsForModel(Chat4Data.id,3);
        }
      }
      if (chatNum > 4) {
        if (Chat5Data.version) {
          formData.append(`Models[4].Id`, Chat5Data.id);
          formData.append(`Models[4].Key`, Chat5Data.version);
          getModelSettingsForModel(Chat5Data.id,4);
        }
        if (Chat6Data.version) {
          formData.append(`Models[5].Id`, Chat6Data.id);
          formData.append(`Models[5].Key`, Chat6Data.version);
          getModelSettingsForModel(Chat6Data.id,5);
    
        }
      }
    }

    formData.append(
      "ConversationId",
      conversationState.activeConversationId || id || activeConId + ""
    );
    if (selcectedPerson?.id && selcectedPerson?.id.length > 0){
      formData.append("PersonaId", selcectedPerson?.id);
    }
    const saveData = () => {
      const connectionId = signalRInstance.connection.connectionId;
      formData.append("ConnectionId", connectionId + "");
      formData.append("Propmpt", query);
      formData.append("IsAnnonymous", isAnnony + "");
      formData.append("PromptId", PromptLibrary.selectedPromptLibrary.id);
      formData.append("OutputLanguage",selectedOutputLang);
      if (!isAnnony) {
        formData.append(
          "ConversationConversationModelIds",
          JSON.stringify(modelsIdsState || conversationModelsIDs)
        );
      }
      if (fileUpload) {
        formData.append("Attachments", fileUpload[0]);
      }
      if (ChatStore.isGenerateImage) {
        formData.append("isGenerateImage", ChatStore.isGenerateImage + "");
      }
      if (ChatStore.isGlobalSearch) {
        formData.append("isNeedWebSearch", ChatStore.isGlobalSearch + "");
      }
      else if(imageUpload){
        formData.append("Attachments",imageUpload[0]);
      }
      Api.post(`/chat?connectionId=${connectionId}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }).catch((err) => {
          HandleErrorForLimitations({user,dispatch,errorMessage:err?.response?.data})
      })
    };
    // Check if the SignalR connection is open, if not, reopen it
    const signalRInstance = SignalRService.getInstance();
    if (signalRInstance.connection.state === "Disconnected") {
      signalRInstance.connection
        .start()
        .then(() => {
          saveData();
        })
        .catch((error) => {});
    } else {
      saveData();
    }
  };

  const createConversation = useCreateConversation();
  const {data:getConversationHistoryData,refetch:getConversationHistory,error:getConversationHistoryError}=useGetConversationHistory({})
  useEffect(()=>{
  if(getConversationHistoryData)
    dispatch(conversationsActions.getConversationSuccess(getConversationHistoryData))
    dispatch(conversationsActions.getconverationsFilteredSuccess(getConversationHistoryData))

  if(getConversationHistoryError)
    dispatch(conversationsActions.getConversationError(getConversationHistoryError.message))
  },[getConversationHistoryData,getConversationHistoryError])
  const handleSendQuery = async(query: string, attachmentFile: FileList|null,imageUpload:{url:string,objectData:File[]|null}|null) => {
    if (attachmentFile) {
      setAttachmentFileData((prev)=>({...prev,
        name: attachmentFile[0].name.split(".").slice(0,-1).join("."),
        extension:getFileExtension( attachmentFile[0].name)||""
      }));
    }
    if(imageUpload?.url){
      setImageUploadedURL(imageUpload.url);
    }

    if (isAuthenticated) {
      if (
        conversationState.activeConversationId !== undefined ||
        null ||
        id !== undefined
      ) {
        handleSendRequest(query, attachmentFile, imageUpload?.objectData, arrayDataModelsIDS);
      } else {
        const conversation = handelNewConversation(query);
        if (conversation) {
          createConversation(
            await conversation,
            conversationWithVersion,
            handleSendRequest,
            query,
            attachmentFile ? attachmentFile : null,
            imageUpload?imageUpload?.objectData: null
          )
            .then(({ activeConId, conversationModelsIds }) => {
              setConConIds(conversationModelsIds);
              handleFileDelete();
              getConversationHistory({});
            })
        }
      }
    } else {
      if (conversationState.activeConversationId !== undefined || null) {
        handleSendRequest(query, attachmentFile,imageUpload?.objectData);
      } else {
        const connectionId = await SignalRService.getInstance().getConnectionId();
        let body = {
          Models: [
            { Id: Chat1Data.id, Key: "" },
            { Id: Chat2Data.id, Key: "" },
            { Id: Chat3Data.id, Key: "" },
            { Id: Chat4Data.id, Key: "" },
            { Id: Chat5Data.id, Key: "" },
            { Id: Chat6Data.id, Key: "" },
          ],
          title: query.slice(0, 20),
          connectionId: connectionId,
          ConversationModels: conversationModelsForAnnonymonus,
          PersonaId: selcectedPerson?.id,
        };
        Api.post(
          "Conversation/CreateAnnonConversation",
          JSON.stringify(body)
        ).then((e) => {
          const { title, id, description, objective } = e?.data?.persona;
          dispatch(setSelectedPersona({ id, title, description, objective }));
          let activeConId = e.data?.id;
          dispatch(conversationsActions.setActiveConversation(activeConId));
          handleSendRequest(query, attachmentFile,imageUpload?.objectData ,conConIds, activeConId);
        });
      }
    }
  };

   useEffect(() => {
    SetActiveChat(0);
  }, [chatNum]);

  const setActiveChat = (index:number)=>{
    setActiveChatIndex(index)
  } 

  const handleShowUpgradeModal = () => {
    setShowClosedChatsModeModal(false);
    dispatch(setShowPlansModal(true))
  }
  const ContainerRef = useRef<HTMLDivElement>(null);
  return (
    <div ref={ContainerRef} className={`Models ${isFullWidth && "full-width"}`}>
      {showImageGeneratorAlert && ChatStore.isGenerateImage ? <ImageGeneratorAlert show={showImageGeneratorAlert} handleClose={handleCloseImageGeneratorAlert}/> : null }
      <div  className={`row modelsContainer column-${chatNum}`}>
        <ClosedChatsModePopup
          open={showClosedChatsModeModal}
          handleClose={() => setShowClosedChatsModeModal(false)}
          handleOpen={() => setShowClosedChatsModeModal(true)}
          showUpgradeToProModal={handleShowUpgradeModal}
          ContainerRef={ContainerRef}
        />
        {
          Array(chatNum)
            .fill(0)
            .map((_, index) => (
                <ChatModel
                key={index}
                page={page}
                currentQuery={query}
                setQuery={setQuery}
                index={index}
                versionName={modelsVersionsState[index]}
                versionId={modelsIdsState[index]}
                attachmentFileData={attachmentFileData?.name ?attachmentFileData : (imageUploadedURL ? {name:"", extension:"", url: imageUploadedURL,type:"image",canDownload:true } : undefined)}
                modelNameFromParent={chatsOpened[index]}
                modelCompanyName={ModelsCompany[index]}
                onModelIsFinished={onModelIsFinished}
                isActiveChat={index === activeChatIndex}
                setActiveChat={setActiveChat}
                emptyAttachmentFile={handleEmptyAttachmentFile}
              />
            ))}
      </div>
      
      {chatNum != 1 && 
        <div className="indicators">
        {Array(chatNum)
          .fill(0)
          .map((_, index) => (
            <div className={`indicator ${index === activeChatIndex && "active"}`} key={index}
             onClick={() => SetActiveChat(index)}></div>
          ))}
      </div>
      }

      <OneQueryInput
        ref={userInputRef}
        receieveUserImageQuery={receieveUserImageQuery}
        handleSendQuery={handleSendQuery}
        inputDisabled={true}
        isResponseRegenerating={maximizedChatResponseIsFinished || inputDisabled}
        setSelectedOutputLang={setSelectedOutputLang}
        setShowImageGeneratorAlert={setShowImageGeneratorAlert}
      />
      {limitAlert.show && 
        <LimitAlert message={limitAlert.message} btnMsg={limitAlert.btnTitle} btnAction={limitAlert.btnAction}/>
      }
    </div>
  );
};

export default Models;
